import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { useHistory } from "react-router-dom";
import "./style.scss";
import LineWithDot from "../../../../../assets/images/Line wit Dot.svg";
import Pagination from "react-js-pagination";
import { Button as MaterialButton } from "@material-ui/core";
import hashImage from "../../../../../assets/images/hashImage.jpeg";
import AnimeList from "../../StartupDashboard/ViewAllMentorList/AnimeList";
import { Country, State, City } from "country-state-city";
import profile from "../../../../../assets/svg/cohortMeetingCircle.svg";
import profileStartup from "../../../../../assets/svg/dashboard/profile-iconRound.svg";
import iconTooltip from "../../../../../assets/svg/dashboard/iconTooltip.svg";
import { getStepperTooltipData } from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import swal from "sweetalert";
import axios from "axios";
import {
  COHORT_NAME_LIST,
  GET_MENTOR_MODULE_COHORT_STATUS,
} from "../../../../common/constants/ApplicationUrl";

import api from "../../../../common/dependencies/utils/Api";

// import {
//   getStartupApplication,
//   getCountersStartUpList,
// } from "../dependencies/action";
import { getPredefineOptionsList } from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import * as moment from "moment";
import Modal from "../../StartupDashboard/MyRequests/Modal/modal";
import Select from "react-select";
import Button from "../../AdminDashboard/Button";
import mentorshipIcon2 from "../../../../../assets/svg/dashboard/view-Mentroships.svg";
import mentorshipIcon from "../../../../../assets/svg/cohortMentorWhite.svg";
import { getNamesList } from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import {
  postMentorModuleCohort,
  postStatusMentorCohort,
  postCounterStartupCohort,
} from "../dependencies/action";
import SubmitAction from "../../../../AdminModule/SubmitAction";
import * as CryptoJS from "crypto-js";
import { PROFILE_KEY } from "../../../../common/constants/actionConstants";
const CohortMentors = (props) => {
  class AesUtil {
    constructor(keySize, iterationCount) {
      this.keySize = keySize / 32;
      this.iterationCount = iterationCount;
    }
  
    generateKey = function (salt, passPhrase) {
      let key = CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), {
        keySize: this.keySize,
        iterations: this.iterationCount,
      });
      return key;
    };
  
    encrypt = function (salt, iv, passPhrase, plainText) {
      let key = this.generateKey(salt, passPhrase);
      let encrypted = CryptoJS.AES.encrypt(plainText, key, {
        iv: CryptoJS.enc.Hex.parse(iv),
      });
      return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    };
  }
  const encryptAES2 = (text, key) => {
    // let iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
    // let salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
  
    // let aesUtil = new AesUtil(128, 1000);
    // let ciphertext = aesUtil.encrypt(salt, iv, key, text);
  
    // let aesText = iv + "::" + salt + "::" + ciphertext;
    
    return btoa(text);
  };
  const {
    getNamesList,
    getNamesListData,
    postMentorModuleCohort,
    tableData,
    postStatusMentorCohort,
    postCounterStartupCohort,
    tableCounterData,
  } = props;
  // const imageUrl = "https://uat-nmp-api.startupindia.gov.in/v1/document/;";
  const [activeText, setActiveText] = useState(false);
  const [activeText2, setActiveText2] = useState(false);
  const [activeText3, setActiveText3] = useState(false);
  const [activeText4, setActiveText4] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [selectedRow, setSelectedRow] = useState("");

  const [mentorShipReqData, setMentorShipReqData] = useState();
  const [tableList, setTableList] = useState();
  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState();
  const history = useHistory();
  const [indexCounter, setIndexCounter] = useState(0);
  const [nameListValue, setNameListValue] = useState([]);
  const [filterName, setFilterName] = useState("");
  const [filterNameValue, setFilterNameValue] = useState("");
  const [filterCohortname, setFilterCohortname] = useState("");
  const [filterCohortId, setFilterCohortId] = useState("");
  const [cohortnameList, setcohortnameList] = useState([]);
  const [cohortnameId, setcohortnameId] = useState([]);
  // const [reloadpage, setReloadpage] = useState(false);
  const LoginRole = JSON.parse(localStorage.getItem("SavedLoggedInData"));

  const defaultFormData = {
    search: "",
    industry: null,
    specialization: null,
    stage: null,
    recognized: "",
    state: "",
    country: "",
  };

  const newCountryArray = [];
  const newStateArray = [];
  const [selectedStatus, setSelectedStatus] = useState("");
  const [formData, setFormData] = useState(defaultFormData);
  const [newCountryOptions, setNewCountryOptions] = useState(newCountryArray);
  const [newStateOptions, setNewStateOptions] = useState(newStateArray);
  const [newCountrySelect, setNewCountrySelect] = useState(false);
  const [allMentorNames, setAllMentorNames] = useState();
  const [filterIndustry, setFilterIndustry] = useState("");
  const [filterFunction, setFilterFunction] = useState("");
  const [filterStage, setFilterStage] = useState("");
  const [filterState, setFilterState] = useState("");
  const [filterCountry, setFilterCountry] = useState("");
  const [showSubmitAction, setShowSubmitAction] = useState(false);
  const [approvaloption, setApprovalOption] = useState();
  const [selectedId, setSelectedId] = useState();
  const [action, setAction] = useState();
  const [submitData, setSubmitData] = useState();
  const [intentToMentor, setIntentToMentor] = useState("");
  const [rejectData, setRejectData] = useState();
  const [cohortfilterGo, setcohortfilterGo] = useState(false);
  const [isShown, setIsShown] = useState(false);
  const [Heading, setHeading] = useState();
  const [InstructionswithRole, setInstructionswithRole] = useState();
  const [SelectPage, setSelectPage] = useState();
  const html = document.getElementsByTagName("html")[0];

  const loginrole = JSON.parse(localStorage.getItem("SavedLoggedInData"))?.role;
  if (loginrole === "Mentor") {
    localStorage.setItem("cohortMentors", "cohortMentors");
  } else {
    localStorage.removeItem("cohortMentors");
    history.push("/startup-dashboard");
  }

  const setModalIsOpenToTrue = () => {
    setIsShown(!isShown);
  };

  const {
    getStartupApplication,
    startUpApplication,
    startUpApplicationPagineate,
    getCountersStartUpList,
    getCounterStartUp,
    getPredefineOptionsList,
    getTableDataPaginate,
    getPredefineOptions,
    updatedrequeststatus,
    getStepperTooltipData,
    getStepperData,
  } = props;
  const currentRoute = window.location.href;
  let sample;
  sample = currentRoute.slice(0, currentRoute.lastIndexOf("/"));

  // useEffect(() => {
  //   if(updatedrequeststatus){
  //     window.location.reload();
  //         }
  // }, [updatedrequeststatus]);
  useEffect(() => {
    html.style.overflow = "auto";

    // localStorage.setItem("cohortMentors", "cohortMentors");
    setTimeout(() => {
      localStorage.removeItem("mentorMentorships");
      localStorage.removeItem("cohortStartup");
      localStorage.removeItem("myrequestMenu");
      localStorage.removeItem("startupListMentor");
      localStorage.removeItem("cohortAdminMentorships");
      localStorage.removeItem("CohortMentorRequest");
      localStorage.removeItem("cohortApplicationMentor");
      localStorage.removeItem("cohortProgram");
      localStorage.removeItem("cohortMatchTable");
      localStorage.removeItem("CohortGroupSession");

      // localStorage.removeItem("cohortMatchTable");
    }, 1000);
    // getAllData()
    // axios({
    //   url: COHORT_NAME_LIST,
    //   method: "post",
    //   data: {
    //     mentorId:
    //       localStorage.getItem("SavedLoggedInData") &&
    //       JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
    //     status: "VERIFIED",
    //   },
    // })
    api
      .POST(COHORT_NAME_LIST, {
        mentorId:
          localStorage.getItem("SavedLoggedInData") &&
          JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
        status: "VERIFIED",
      })
      .then((res) => {
        const cohortnameArray = [];

        // setCounterData(res.data?.data)
        res.data.data &&
          res.data.data.map((item, index) => {
            // const params = {
            //   label: item.name,
            //   value: item.id,
            // };
            // cohortnameArray.push(params);
            if (index === 0) {
              let arr2 = {
                label: "Select Cohort Name",
                value: "select",
              };
              setcohortnameList((oldArray) => [...oldArray, arr2]);
            }
            let arr = {
              label: item.name,
              value: item.id,
            };
            if (res.data.data.length >= cohortnameList.length)
              setcohortnameList((oldArray) => [...oldArray, arr]);
          });

        // setcohortnameList(cohortnameArray);
        // setcohortnameId(cohortidArray);
      })
      .catch((err) => {});

    // axios({
    //   url: COHORT_NAME_LIST,
    //   method: "post",
    //   data: {
    //     status: "VERIFIED",
    //     mentorId:
    //       localStorage.getItem("SavedLoggedInData") &&
    //       JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
    //   },
    // })
    api
      .POST(COHORT_NAME_LIST, {
        status: "VERIFIED",
        mentorId:
          localStorage.getItem("SavedLoggedInData") &&
          JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
      })
      .then((res) => {
        // const cohortnameArray = [];
        const cohortidArray = [];

        res.data.data &&
          res.data.data.map((item, index) => {
            // const params = {
            //   label: `C${item.id.slice(-6)}`,
            //   value: item.id,
            // };
            // cohortidArray.push(params);
            if (index === 0) {
              let arr2 = {
                label: "Select Cohort Id",
                value: "select",
              };
              setcohortnameId((oldArray) => [...oldArray, arr2]);
            }
            let arr = {
              label: `C${item.id.slice(-6)}`,
              value: item.id,
            };
            if (res.data.data.length >= cohortnameId.length)
              setcohortnameId((oldArray) => [...oldArray, arr]);
          });

        // setcohortnameList(cohortnameArray);
        // setcohortnameId(cohortidArray);
      })
      .catch((err) => {});
  }, []);
  const getTableDataStatus2 = (status) => {
    setActivePage(1);

    let params = {
      // cohortId: filterCohortId,
      cohortAdminId: LoginRole.id,
      // requestStatus: "",
      industry:
        filterIndustry && filterIndustry == "select" ? "" : filterIndustry,
      function:
        filterFunction && filterFunction == "select" ? "" : filterFunction,
      stage: filterStage && filterStage == "select" ? "" : filterStage,
      cohortId: filterCohortId == "select" ? "" : filterCohortId,
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "id",
        sortOrder: "ASC",
      },
      searchField: "",
      searchKey: "",
      requestStatus: selectedStatus,
    };
    postMentorModuleCohort(params);
    // setcohortfilterGo(!cohortfilterGo);
  };
  useEffect(() => {
    if (props?.location?.state?.requestStatus === undefined) {
      setActiveText(true);
    } else if (props?.location?.state?.requestStatus === "pending") {
      setActiveText2(true);
    } else if (props.location.state.requestStatus === "viewAll") {
      setActiveText(true);
    } else setActiveText(true);
  }, []);
  useEffect(() => {
    getStepperTooltipData();
  }, []);
  useEffect(() => {
    //
    //
    setHeading(getStepperData?.Guidedinstructions[0].Heading);
    setInstructionswithRole(
      getStepperData?.Guidedinstructions[0].InstructionswithRole
    );
    setSelectPage(getStepperData?.Guidedinstructions[0].SelectPage);
  }, [getStepperData]);
  useEffect(() => {
    let params = {
      // cohortId: filterCohortId,
      cohortAdminId: LoginRole.id,
      requestStatus: "",
      industry:
        filterIndustry && filterIndustry == "select" ? "" : filterIndustry,
      function:
        filterFunction && filterFunction == "select" ? "" : filterFunction,
      stage: filterStage && filterStage == "select" ? "" : filterStage,
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "id",
        sortOrder: "ASC",
      },
      searchField: "",
      searchKey: "",
    };
    postMentorModuleCohort(params);
  }, [cohortfilterGo]);
  const callTableData = (status) => {
    // setSelectedStatus(status);
    setActivePage(1);
    let params = {
      // cohortId: filterCohortId,
      cohortAdminId: LoginRole.id,
      requestStatus: status,
      industry:
        filterIndustry && filterIndustry == "select" ? "" : filterIndustry,
      function:
        filterFunction && filterFunction == "select" ? "" : filterFunction,
      stage: filterStage && filterStage == "select" ? "" : filterStage,
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "id",
        sortOrder: "ASC",
      },
      searchField: "",
      searchKey: "",
    };
    postMentorModuleCohort(params);
  };

  useEffect(() => {}, [tableData]);
  // useEffect(() => {}, [reloadpage]);
  useEffect(() => {
    let params = {
      listKey: "Startup",
    };
    getNamesList(params);
  }, []);
  useEffect(() => {
    let nameArrList = [];

    getNamesListData?.forEach((element, index) => {
      if (index === 0) {
        let arr2 = {
          value: "Select",
          label: "Select Startup",
        };
        setNameListValue((oldArray) => [...oldArray, arr2]);
      }
      let arr = {
        value: element.id,
        label: element.name,
      };
      if (getNamesListData.length >= nameListValue.length)
        setNameListValue((oldArray) => [...oldArray, arr]);
    });
  }, [getNamesListData]);
  useEffect(() => {
    postCounterFn();
  }, []);
  const postCounterFn = () =>{
    let params = {
      cohortAdminId: LoginRole.id,
      forMentor: true,
      forStartup: false,
    };
    postCounterStartupCohort(params);
  }
  useEffect(() => {}, [tableCounterData]);

  //   const getStartupApplicationTable = (status) => {
  //     setActivePage(1);
  //     let params = {
  //       requestedBy: "",
  //       status: status,
  //       pageFilter: {
  //         currentPage: 0,
  //         pageSize: 10,
  //         sortField: "id",
  //         sortOrder: "ASC",
  //       },
  //       searchField: filterNameValue == "Select" ? "" : filterNameValue,
  //       searchKey: null,
  //       country: "",
  //       // id: formData?.name?.value == "select" ? null : formData?.name?.value, // optional
  //       state: formData.state == "select" ? null : formData?.state?.value, // optional
  //       industry: formData.industry == "select" ? "" : formData?.industry?.value, // optional
  //       function: formData.function == "select" ? "" : formData?.function?.value, // optional
  //       stage: formData.stage == "select" ? "" : formData?.stage?.value,
  //       // country: "",
  //       // state: "",
  //       // industry: "", // optional
  //       // function: "", // optional
  //       // stage: "",
  //     };
  //     getStartupApplication(params);
  //   };
  //   const getStartUpListDataNameSearch = (name) => {
  //     let params = {
  //       requestedBy: "",
  //       status: "",
  //       pageFilter: {
  //         currentPage: 0,
  //         pageSize: 10,
  //         sortField: "id",
  //         sortOrder: "ASC",
  //       },
  //       searchField: name === "Select" ? "" : name,
  //       searchKey: null,
  //       status: selectedStatus,
  //       country: "",
  //       // id: formData?.name?.value == "select" ? null : formData?.name?.value, // optional
  //       state: formData.state == "select" ? null : formData?.state?.value, // optional
  //       industry: formData.industry == "select" ? "" : formData?.industry?.value, // optional
  //       function: formData.function == "select" ? "" : formData?.function?.value, // optional
  //       stage: formData.stage == "select" ? "" : formData?.stage?.value,
  //     };
  //     getStartupApplication(params);
  //   };
  const approvalOptions = [
    {
      value: "Approve",
      label: "Accept",
    },
    { value: "Reject", label: "Decline" },
  ];

  useEffect(() => {
    getPredefineOptionsList();
    Country.getAllCountries().map((item) => {
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };

      newCountryArray.push(newObject);
      setNewCountryOptions(newCountryArray);
    });
    State.getStatesOfCountry("IN").map((item) => {
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };

      newStateArray.push(newObject);
      setNewStateOptions(newStateArray);
    });
  }, []);
  const updateMentorStatus = (params) => {
    api
      .POST(`${GET_MENTOR_MODULE_COHORT_STATUS}`, params)
      .then((response) => {
        const { data, status } = response || {};
        if (status === 200) {
          if (data?.success == false) {
            swal({
              title: "Warning",
              text: `Mentor Request ` + params?.requestStatus + ` Not Sent!! `,
              icon: "info",
            });
          } else {
            swal({
              title: "Thank You ",
              text:
                `Mentor Request ` + params?.requestStatus + ` Successfully!! `,
              icon: "success",
              buttons: {
                closemodal: {
                  text: "OK",
                },
              },
            }).then((value) => {
              switch (value) {
                case "closemodal":
                  // console.log(value, "value");

                  break;
                default:
                // console.log("cannot close modal");
              }
            });
            // window.location.reload();
          }
        } else {
          swal({
            title: "WARNING",
            text: `Failed to Update Request `,
            icon: "info",
          });
        }
      })
      .catch((e) => {
        swal({
          title: "WARNING",
          text: `Failed to Update Request `,
          icon: "info",
        });
        return Promise.reject(e);
      });
  };
  //   useEffect(() => {
  //     let params = {
  //       requestedBy: "",
  //       status: "",
  //       pageFilter: {
  //         currentPage: 0,
  //         pageSize: 10,
  //         sortField: "id",
  //         sortOrder: "ASC",
  //       },
  //       searchField: null,
  //       searchKey: null,
  //       country: "",
  //       // id: formData?.name?.value == "select" ? null : formData?.name?.value, // optional
  //       state: formData.state == "select" ? null : formData?.state?.value, // optional
  //       industry: formData.industry == "select" ? "" : formData?.industry?.value, // optional
  //       function: formData.function == "select" ? "" : formData?.function?.value, // optional
  //       stage: formData.stage == "select" ? "" : formData?.stage?.value,
  //     };
  //     getStartupApplication(params);
  //   }, []);

  const customStyles = {
    container: (provided) => ({
      ...provided,
      width: 220,
    }),
    option: (provided, state) => ({
      ...provided,

      textAlign: "left",
    }),
    menu: (base) => ({
      ...base,
      width: "max-content",
      minWidth: "100%",
      fontSize: "14px",
    }),
  };
  const customStyles2 = {
    container: (provided) => ({
      ...provided,
      width: 150,
    }),
    option: (provided, state) => ({
      ...provided,

      textAlign: "left",
    }),
    menu: (base) => ({
      ...base,
      width: "max-content",
      minWidth: "100%",
      fontSize: "14px",
    }),
  };
  useEffect(() => {
    getPredefineOptionsList();
  }, []);
  //   useEffect(() => {
  //     if (
  //       history?.location?.state?.requestStatus === "viewAll" ||
  //       history?.location?.state?.requestStatus === undefined
  //     ) {
  //       getStartupApplicationTable("");
  //     } else {
  //       getStartupApplicationTable("PENDING");
  //     }
  //   }, []);
  const ViewApplication = (dpiitNo) => {
    let reRoute = window.open(sample + "/view-StartupApplication", "_blank");
    reRoute.id = dpiitNo;
    reRoute.fromModule = "startUpApplications";
    // history.push({
    //   pathname: "/view-StartupApplication",
    //   state: dpiitNo
    //   // { data: item, prevPage: "startUpList" },
    // });
  };
  const redirectProfile = (dpiitNo) => {
    let reRoute = window.open(sample + "/startup-profile", "_blank");
    reRoute.id = dpiitNo;
    // history.push({
    //   pathname: "/startup-profile",
    //   state: dpiitNo,
    //   // state: { data: props.history.location.state, prevPage: "startUpDash" },
    // });
  };
  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
    let params = {
      // cohortId: filterCohortId,
      cohortAdminId: LoginRole.id,
      requestStatus: selectedStatus,
      industry:
        filterIndustry && filterIndustry == "select" ? "" : filterIndustry,
      function:
        filterFunction && filterFunction == "select" ? "" : filterFunction,
      stage: filterStage && filterStage == "select" ? "" : filterStage,
      pageFilter: {
        currentPage: pageNumber - 1,
        includeCount: true,
        pageSize: 10,
        sortField: "id",
        sortOrder: "ASC",
      },
      searchField: "",
      searchKey: "",
    };
    postMentorModuleCohort(params);
  };
  //   useEffect(() => {
  //     let params = {
  //       requestedBy: "",
  //     };
  //     getCountersStartUpList(params);
  //   }, []);
  //   useEffect(() => {
  //     setTableList(startUpApplication);
  //     let data = startUpApplication?.requestJson;
  //     setMentorShipReqData(data);
  //   }, [startUpApplication]);
  const getStartUpId = (string) => {
    const value = string.substring(string?.length - 6);
    return value;
  };

  const ViewProfile = (item, id) => {
    setSelectedRow(id);

    let reRoute = window.open(sample + `/mentor-profile/${item}`, "_blank");
    reRoute.id = item;
    //
    // history.push({
    //   pathname: `/mentor-profile/${item.email}`,
    //   state: { prevPage: "mentorPage",data:item },
    // });
  };
  const onclickShowSubmitAction = (action, id, status) => {
    setShowSubmitAction(true);
    setAction(action);
    let params = {
      id: id,
      status: status,
    };
    setSubmitData(params);
  };
  const clickOnClose = () => {
    setShowSubmitAction((x) => !x);
    setShowSubmitAction(!showSubmitAction);
    setApprovalOption("Select");
    localStorage.setItem("cohortMentors", "cohortMentors");
    // history.push("/dashboard");
    window.location.reload();
  };
  return (
    <>
      <div className="chrtadminmenreqmenloginmaindiv">
        <div
          className="dashboard-main2 mentorreqdiv"
          style={{ background: "none" }}
        >
          {intentToMentor ? (
            <div
              className="dashboard-bottom-btn4 topbackbtnmentorlist"
              style={{ background: "transparent", border: "none" }}
            >
              <Modal
                modalOpen={modalOpen}
                setModalOpen={setModalOpen}
                modalData={modalData}
                intentToMentor={intentToMentor}
                hideData={true}
              />
            </div>
          ) : (
            ""
          )}
          <div className="iconWith-heading cohortappiconwith">
            <div style={{ width: "100%" }}>
              <h3
                className="sub-heading fadeInDown wow"
                style={{ color: "#262838", fontWeight: 600, fontSize: "28px" }}
              >
                MAARG Portal by Startup India
              </h3>
              <h3 className="dashboard-sub-heading fadeInDown wow">
                COHORT ADMIN: MENTOR REQUESTS
              </h3>
            </div>
            <div
              className="tooltipshow eyeIcon"
              // onClick={() => {
              //   // html.style.overflow = "hidden";
              //   if (html.style.overflow == "auto") {
              //     html.style.overflow = "hidden";
              //   } else {
              //     html.style.overflow = "auto";
              //   }
              // }}
            >
              <div className="newuserTooltip">
                <img
                  className="iconbtn top-btn"
                  src={iconTooltip}
                  onClick={() => {
                    setModalIsOpenToTrue();
                    if (html.style.overflow == "auto") {
                      html.style.overflow = "hidden";
                    } else {
                      html.style.overflow = "auto";
                    }
                  }}
                  width={60}
                />
                <span
                  className="tooltiptext tooltip-bottom "
                  style={{ width: "130px", top: "50px", left: "20px" }}
                >
                  View Instructions
                </span>
              </div>
            </div>
            {isShown && (
              <div>
                <AnimeList
                  setModalIsOpenToTrue={setModalIsOpenToTrue}
                  Heading={Heading}
                  InstructionswithRole={InstructionswithRole}
                  SelectPage={SelectPage}
                />
              </div>
            )}
          </div>
        </div>

        <div className="col-md-11 display-center mobileviewcohortappli">
          <div className="admin-bottom-cardNew2 row mobileviewmentorbelow">
            <div
              className="mentorImageParent"
              style={{
                background: "none",
                border: "0px",
                borderRadius: "0px",
              }}
            >
              <img src={mentorshipIcon} className="sidebar-dashboard-icon003" />
            </div>
            <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2 mentorAppButton">
              <div className="dashboard-bottom-btn0002">
                <p className="text-white0002"> MENTOR REQUESTS</p>
              </div>
            </div>
            <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2 startUpDashBox0004 newuserTooltip totreceivedreq">
              <p
                onClick={() => {
                  setActiveText(true);
                  setActiveText2(false);
                  setActiveText3(false);
                  setActiveText4(false);
                  callTableData("");
                  // setSelectedStatus("");
                  //   getStartupApplicationTable("");
                }}
                style={{
                  color: activeText ? "#277acc" : "#838186",
                }}
                className="admindasheaderoptions"
              >
                TOTAL RECEIVED :{" "}
                {tableCounterData && tableCounterData.total !== null
                  ? tableCounterData.total
                  : 0}
              </p>
              <span
                className="tooltiptext   tooltip-bottom"
                style={{ left: "77px", width: "280px" }}
              >
                Click to View Total Received Requests
              </span>
              {activeText ? (
                <img className="requestStatusBar" src={LineWithDot} />
              ) : (
                ""
              )}
            </div>
            <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2 newuserTooltip totreceivedreq2">
              <p
                onClick={() => {
                  setActiveText2(true);
                  setActiveText(false);
                  setActiveText3(false);
                  setActiveText4(false);
                  setSelectedStatus("Requested");
                  callTableData("Requested");
                }}
                style={{ color: activeText2 ? "#277acc" : "#838186" }}
                className="admindasheaderoptions applicationHeading28"
              >
                {" "}
                PENDING :{" "}
                {tableCounterData && tableCounterData.requested !== null
                  ? tableCounterData.requested
                  : 0}
                {/* {getTableCounterData && Math.abs(getTableCounterData.pending)} */}
                {/* {getCounterStartUp && getCounterStartUp.pending !== null
                  ? getCounterStartUp.pending
                  : 0} */}
              </p>
              <span
                className="tooltiptext   tooltip-bottom"
                style={{ left: "77px", width: "250px" }}
              >
                Click to View Pending Requests
              </span>
              {activeText2 ? (
                <img
                  className="requestStatusBar positionBar0009 totreceivedreq2bar"
                  src={LineWithDot}
                />
              ) : (
                ""
              )}
            </div>
            <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2 startUpDashBox0002 newuserTooltip totreceivedreq3">
              <p
                onClick={() => {
                  setActiveText3(true);
                  setActiveText(false);
                  setActiveText2(false);
                  setActiveText4(false);
                  // getStartupApplicationTable("ACCEPTED");
                  // setSelectedStatus("VERIFIED");
                  callTableData("Accepted");
                  setSelectedStatus("Accepted");
                }}
                style={{ color: activeText3 ? "#277acc" : "#838186" }}
                className="admindasheaderoptions applicationHeading3"
              >
                {" "}
                ACCEPTED :{" "}
                {tableCounterData && tableCounterData.accepted !== null
                  ? tableCounterData.accepted
                  : 0}
                {/* {getTableCounterData && Math.abs(getTableCounterData.approved)} */}
                {/* {getCounterStartUp && getCounterStartUp.accepted !== null
                  ? getCounterStartUp.accepted
                  : 0} */}
              </p>
              <span
                className="tooltiptext   tooltip-bottom"
                style={{ left: "77px", width: "250px" }}
              >
                Click to View Accepted Requests
              </span>
              {activeText3 ? (
                <img
                  className="requestStatusBar positionBar2 totreceivedreq3bar"
                  src={LineWithDot}
                />
              ) : (
                ""
              )}
            </div>
            <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2 startUpDashBox0003 newuserTooltip totreceivedreq4">
              <p
                onClick={() => {
                  setActiveText3(false);
                  setActiveText(false);
                  setActiveText2(false);
                  setActiveText4(true);
                  callTableData("Declined");
                  // getStartupApplicationTable("REJECTED");
                  setSelectedStatus("Declined");
                  // getMentorApplications("VERIFIED");
                }}
                style={{ color: activeText4 ? "#277acc" : "#838186" }}
                className="admindasheaderoptions"
              >
                {" "}
                DECLINED :{" "}
                {tableCounterData && tableCounterData.declined !== null
                  ? tableCounterData.declined
                  : 0}
                {/* {getCounterStartUp && getCounterStartUp.rejected !== null
                  ? getCounterStartUp.rejected
                  : 0} */}
              </p>
              <span
                className="tooltiptext   tooltip-bottom"
                style={{ left: "25px", width: "250px" }}
              >
                Click to View Declined Requests
              </span>
              {activeText4 ? (
                <img
                  className="requestStatusBar statusBarLine3 totreceivedreq4bar"
                  src={LineWithDot}
                />
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="filter-row filter-row-common filterDivMentorapp">
            {/* <div className="container"> */}
            <div>
              <form className="formContainer newfilterdivnow">
                <div className="row desktopFilterRow">
                  {/* <div
                      className="col-md-1 filter-text3"
                      style={{
                        alignItems: "center",
                        display: "flex",
                        color: "#838186",
                        fontWeight: "400",
                        height: "40px",
                        fontSize: "18px",
                      }}
                    >
                      Filter by
                    </div> */}
                  <div className="col-11 d-flex justify-content-between filter-bigDiv">
                    {/* <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2">
                      <Select
                        required={true}
                        id="searchBy"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="searchBy"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.name}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              name: e.name == "select" ? null : e,
                            };
                          });
                          setFilterName(e.name);
                          setFilterNameValue(e.value);
                          
                        //   getStartUpListDataNameSearch(e.value);
                        }}
                        options={nameListValue.length > 0 ? nameListValue : ""}
                        placeholder="Search StartUp"
                      />
                    </div> */}
                    <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip">
                      <Select
                        required={true}
                        id="cohortorgname"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="cohortorgname"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.cohortorgname}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              cohortorgname: e.value == "select" ? null : e,
                            };
                          });
                          setFilterCohortId(e.value);
                        }}
                        // options={getPredefineOptions?.industry_options}
                        options={cohortnameList}
                        placeholder="Cohort Name"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "90px", top: "45px", width: "160px" }}
                      >
                        Search Cohort Name
                      </span>
                    </div>
                    <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip">
                      <Select
                        required={true}
                        id="cohortId"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="cohortId"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.cohortId}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              cohortId: e.value == "select" ? null : e,
                            };
                          });
                          setFilterCohortId(e.value);
                        }}
                        // options={getPredefineOptions?.industry_options}
                        options={cohortnameId}
                        placeholder="Cohort ID"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "90px", top: "45px", width: "150px" }}
                      >
                        Search Cohort ID
                      </span>
                    </div>
                    <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip">
                      <Select
                        required={true}
                        id="Industry"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="industry"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.industry}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              industry: e.value == "select" ? null : e,
                            };
                          });
                          setFilterIndustry(e.value);
                        }}
                        options={getPredefineOptions?.industry_options}
                        placeholder="Industry"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "90px", top: "45px", width: "130px" }}
                      >
                        Search Industry
                      </span>
                    </div>
                    <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip">
                      <Select
                        required={true}
                        id="specialization"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="specialization"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.function}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              function: e.value == "select" ? null : e,
                            };
                          });
                          setFilterFunction(e.value);
                        }}
                        options={getPredefineOptions?._specialisation}
                        placeholder="Function"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "90px", top: "45px", width: "130px" }}
                      >
                        Search Function
                      </span>
                    </div>

                    <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip">
                      <Select
                        required={true}
                        id="stage"
                        // label="Gender*"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="stage"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.stage}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              stage: e.value == "select" ? null : e,
                            };
                          });
                          setFilterStage(e.value);
                        }}
                        options={getPredefineOptions?.stage_of_startup_options}
                        placeholder="Stage"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "90px", top: "45px", width: "130px" }}
                      >
                        Search Stage
                      </span>
                    </div>

                    {/* <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2">
                      <Select
                        required={true}
                        id="state"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="state"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.state}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              state: e.value == "select" ? null : e,
                            };
                          });
                          setFilterState(e.value);
                        }}
                        options={newStateOptions}
                        placeholder="State"
                      />
                    </div> */}
                  </div>

                  <div className="apply-section d-flex justify-content-end col-1 newuserTooltip">
                    <Button
                      // style={{
                      //   background: "#277acc",
                      // }}
                      // onClick={handleClickOfFilter}
                      //   onClick={() => getStartupApplicationTable(selectedStatus)}
                      onClick={getTableDataStatus2}
                      text="GO"
                      className="filter-button top-btn newcoloredbtn startupColorBtn"
                    ></Button>
                    <span
                      className="tooltiptext   tooltip-bottom"
                      style={{
                        left: "46px",
                        width: "126px",
                        height: "48px",
                        top: "42px",
                      }}
                    >
                      Click to Apply Filters
                    </span>
                    {/* <Button
                      icon={<img src={arrow} className="search-icon" />}
                      text=""
                      onClick={() => getMentorApplications(selectedStatus)}
                      className="green-btn filter-btn apply-admin-dashbtn newfilterBtnallmentor"
                    /> */}
                  </div>
                </div>

                <div className="row mobileFilterRow">
                  <div className="col-md-1 filter-text">Filter by</div>

                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="cohortorgname"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="cohortorgname"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.cohortorgname}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            cohortorgname: e.value == "select" ? null : e,
                          };
                        });
                        setFilterCohortId(e.value);
                      }}
                      // options={getPredefineOptions?.industry_options}
                      options={cohortnameList}
                      placeholder="Cohort Name"
                    />
                  </div>

                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="cohortId"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="cohortId"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.cohortId}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            cohortId: e.value == "select" ? null : e,
                          };
                        });
                        setFilterCohortId(e.value);
                      }}
                      // options={getPredefineOptions?.industry_options}
                      options={cohortnameId}
                      placeholder="Cohort ID"
                    />
                  </div>

                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="Industry"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="industry"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.industry}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            industry: e.value == "select" ? null : e,
                          };
                        });
                        setFilterIndustry(e.value);
                      }}
                      options={getPredefineOptions?.industry_options}
                      placeholder="Industry"
                    />
                  </div>
                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="specialization"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="specialization"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.function}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            function: e.value == "select" ? null : e,
                          };
                        });
                        setFilterFunction(e.value);
                      }}
                      options={getPredefineOptions?._specialisation}
                      placeholder="Function"
                    />
                  </div>

                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="stage"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="stage"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.stage}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            stage: e.value == "select" ? null : e,
                          };
                        });
                        setFilterStage(e.value);
                      }}
                      options={getPredefineOptions?.stage_of_startup_options}
                      placeholder="Stage"
                    />
                  </div>
                  {/* <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="country"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="country"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.country}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            country: e.value == "select" ? null : e,
                          };
                        });

                        setFilterCountry(e.label);

                        if (e.label === "India") {
                          setNewCountrySelect(true);
                        } else {
                          setNewCountrySelect(false);
                        }
                        setNewStateOptions("");
                      }}
                      options={newCountryOptions}
                      placeholder="Country"
                    />
                  </div>

                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="state"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="state"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.state}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            state: e.value == "select" ? null : e,
                          };
                        });
                        setFilterState(e.value);
                      }}
                      options={newStateOptions}
                      placeholder="State"
                    />
                  </div> */}
                  <div
                    className="col-md-1 apply-section"
                    style={{ color: "transparent" }}
                  >
                    <Button
                      className="green-btn filter-btn"
                      onClick={getTableDataStatus2}
                      text="GO"
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div className="totalTableCount">
            Total Mentor Requests : {getTableDataPaginate?.totalElements} &lt;{" "}
            {getTableDataPaginate?.currentPage} of{" "}
            {getTableDataPaginate?.numPages} &gt;{" "}
          </div>
          {/* {startUpApplication && startUpApplication?.length > 0 ? ( */}
          {tableData && tableData.length > 0 ? (
            <div>
              <div className="table-container mt-2">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th
                        className=" fixColumbnWidth4"
                        style={{ verticalAlign: "middle" }}
                      >
                        {" "}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                          }}
                        >
                          NO.
                        </div>
                      </th>
                      <th
                        className="fixColumbnWidth"
                        colspan="2"
                        style={{ verticalAlign: "middle" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",

                            minWidth: "9.9rem",
                            maxWidth: "10rem",
                          }}
                        >
                          MENTOR
                        </div>
                      </th>
                      <th
                        className="fixColumbnWidth4"
                        style={{
                          whitespace: "nowrap",
                          fontSize: "15.3px",
                          minWidth: "6.9rem",
                          maxWidth: "7rem",
                          verticalAlign: "middle",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",

                            minWidth: "8.4rem",
                            maxWidth: "8.5rem",
                          }}
                        >
                          REQUEST ID
                        </div>
                      </th>
                      <th
                        className="fixColumbnWidth7"
                        style={{ verticalAlign: "middle" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                          }}
                        >
                          INTENT TO BE PART OF COHORT
                        </div>
                      </th>
                      <th
                        className=""
                        style={{
                          whitespace: "nowrap",
                          fontSize: "15.3px",
                          verticalAlign: "middle",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                          }}
                        >
                          COHORT
                        </div>
                      </th>
                      <th
                        style={{ verticalAlign: "middle" }}
                        className="fixColumbnWidth7"
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",

                            minWidth: "7.9rem",
                            maxWidth: "9rem",
                          }}
                        >
                          REQUEST STATUS
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* {tableData && tableData.length > 0 ? ( */}
                    {tableData.map((item, index) => (
                      <tr
                        key={index}
                        className={
                          item.id === indexCounter ? "purpleBackground" : ""
                        }
                      >
                        {getTableDataPaginate.currentPage === 1 ? (
                          <td style={{ verticalAlign: "middle" }}>
                            {index + 1}
                          </td>
                        ) : (
                          <td style={{ verticalAlign: "middle" }}>
                            {index +
                              1 +
                              10 * (getTableDataPaginate.currentPage - 1)}
                          </td>
                        )}
                        <td
                          style={{ verticalAlign: "middle" }}
                          className="chrtadmnmntrreqmntrdtalsmbl"
                        >
                          <div
                            className="newuserTooltip"
                            style={{
                              width: "100px",
                              height: "100px",
                              maxWidth: "none",

                              objectFit: "contain",
                            }}
                            onClick={() => {
                              const currentRoute = window.location.href;
                              let sample;
                              sample = currentRoute.slice(0, currentRoute.lastIndexOf("/"));
                              window.open(sample + `/mentor-profile/${encryptAES2(item.mentor.email,PROFILE_KEY)}`, "_blank");
                              // let reRoute = window.open(
                              //   sample + `/mentor-profile/${item.mentor.email}`,
                              //   "_blank"
                              // );
                              // reRoute.id = "daksha.hirpara@gmail.com";
                            }}
                          >
                            <img
                              src={
                                item.mentor.image !== null &&
                                item.mentor.image !== ""
                                  ? item.mentor.image
                                  : hashImage
                              }
                              className="sidebar-dashboard-icon2"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                                cursor: "pointer",
                              }}
                            />
                            <span
                              className="tooltiptext tooltip-bottom "
                              style={{
                                left: "40px",
                                top: "6.5rem",
                                width: "150px",
                              }}
                            >
                              View Mentor Profile
                            </span>
                            <div
                              style={{
                                cursor: "default",
                                //  position:"relative",
                                //  top:"2.5rem",
                                minWidth: "100%",
                              }}
                              className="dontshowmobiledivnowchrtreq"
                            >
                              {item.mentor.applicant_name}
                              <br />
                              {"M" +
                                item.mentor.id.substring(
                                  item.mentor.id.length - 6
                                )}
                              {/* {"M"+item.mentor.id.substring(item.mentor.id - 6)} */}
                            </div>
                            <div
                              className="newuserTooltip chrtadmnmntrreqmntrdtalsicon"
                              style={{
                                // position: "absolute",
                                bottom: 0,
                                right: 0,
                                // padding: "12px",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                 window.open(sample + `/mentor-profile/${encryptAES2(item,PROFILE_KEY)}`, "_blank");
                                // reRoute.id = "daksha.hirpara@gmail.com";
                              }}
                            >
                              <img
                                src={profileStartup}
                                width={40}
                                height={40}
                              />
                              <span
                                className="tooltiptext tooltip-bottom "
                                style={{
                                  left: "26px",
                                  top: "60px",
                                  width: "150px",
                                }}
                              >
                                View Mentor Profile
                              </span>
                            </div>
                          </div>
                        </td>
                        <td
                          style={{
                            position: "relative",
                            verticalAlign: "middle",
                          }}
                          className="dntshowdesktopdivshrtreqmbl"
                        >
                          <div
                            style={{
                              cursor: "default",
                              //  position:"relative",
                              //  top:"2.5rem",
                              minWidth: "200px",
                            }}
                          >
                            {item.mentor.applicant_name}
                            <br />
                            {"M" +
                              item.mentor.id.substring(
                                item.mentor.id.length - 6
                              )}
                            {/* {"M"+item.mentor.id.substring(item.mentor.id - 6)} */}
                          </div>
                          <div
                            className="newuserTooltip"
                            style={{
                              position: "absolute",
                              bottom: 0,
                              right: 0,
                              padding: "12px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              window.open(sample + `/mentor-profile/${encryptAES2(item,PROFILE_KEY)}`, "_blank");
                              // let reRoute = window.open(
                              //   sample + `/mentor-profile/${item.mentor.email}`,
                              //   "_blank"
                              // );
                              // reRoute.id = "daksha.hirpara@gmail.com";
                            }}
                          >
                            <img src={profileStartup} width={40} height={40} 
                              onClick={() => {
                              
                                window.open(sample + `/mentor-profile/${encryptAES2(item.mentor.email,PROFILE_KEY)}`, "_blank");
                                // let reRoute = window.open(
                                //   sample + `/mentor-profile/${item.mentor.email}`,
                                //   "_blank"
                                // );
                                // reRoute.id = "daksha.hirpara@gmail.com";
                              }}/>
                            <span
                              className="tooltiptext tooltip-bottom "
                              style={{
                                left: "26px",
                                top: "60px",
                                width: "150px",
                              }}
                            >
                              View Mentor Profile
                            </span>
                          </div>
                        </td>
                        <td style={{ verticalAlign: "middle" }}>
                          <div className="reqidtddivchrtreqmntrloginmbl">
                            <div className="newuserTooltip">
                              <a
                                className={
                                  item?.intentToMentor !== ""
                                    ? "color-green"
                                    : "colorGreen2"
                                }
                                onClick={() => {
                                  // setIndexCounter(item.requestId);
                                  if (item?.intentToMentor !== "") {
                                    setModalData(item.requestJson);
                                    setIntentToMentor(item.intentToMentor);
                                    setModalOpen(true);
                                  }
                                }}
                              >
                                {item?.id?.substring(item?.id?.length - 6)}
                              </a>
                              {item?.intentToMentor !== "" ? (
                                <span
                                  className="tooltiptext  tooltip-bottom"
                                  style={{
                                    top: "30px",
                                    left: "20px",
                                    width: "150px",
                                  }}
                                >
                                  View Cohort Intent
                                  {/* <h5 style={{ color: "rgb(255, 255, 255)" }}>
                                  INTENT TO MENTOR
                                </h5> */}
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                            <div className="mt-2">
                              {moment(item.dateApplied).format("DD/MM/YYYY")}
                              <br></br>
                              {moment(item.dateApplied).format("hh:mm a")}
                            </div>
                          </div>
                        </td>
                        <td
                          style={{ verticalAlign: "middle" }}
                          className="myRequestActionTableFix intntchrtreqmbltd"
                        >
                          {item?.intentToMentor === "" ? (
                            "This Mentor is added by the Cohort Admin"
                          ) : item?.intentToMentor?.length > 197 ? (
                            <div
                              style={{
                                flexDirection: "column",
                                display: "flex",
                                justifyContent: "left",
                                // height: "110px",

                                // maxWidth: "240px",
                              }}
                            >
                              {/* {item?.intentToMentor.substring(0, 197)} */}
                              {/* <div className="tooltipicon">
                                <svg
                                  style={{
                                    position: "relative",
                                    top: "0.1rem",
                                    cursor: "pointer",
                                  }}
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="20"
                                  height="20"
                                  fill="currentColor"
                                  class="bi bi-three-dots"
                                  viewBox="0 0 16 16"
                                >
                                  <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" />
                                </svg>
                                <span
                                  className="tooltiptext7"
                                  style={{ top: "-216px", left: "98px" }}
                                >
                                  <h5 style={{ color: "#fff" }}>
                                    INTENT TO BE PART OF COHORT
                                  </h5>
                                  {item?.intentToMentor}
                                </span>
                              </div> */}
                              <div
                                className="tooltipicon"
                                style={{ cursor: "pointer" }}
                              >
                                {item?.intentToMentor.slice(0, 80)}{" "}
                                {item?.intentToMentor.length > 40 && <b>...</b>}
                                <span className="tooltiptext7">
                                  <h5 style={{ color: "#fff" }}>
                                    INTENT TO BE PART OF COHORT
                                  </h5>
                                  {item?.intentToMentor}
                                </span>
                              </div>
                            </div>
                          ) : (
                            item?.intentToMentor
                          )}
                        </td>
                        {/* <td className="cohortStartupTableFix">
                          {item.intentToMentor}
                        </td> */}
                        <td
                          className="cohortStartupTableFix2 chrtchrtreqmbltddivtd"
                          style={{ position: "relative" }}
                        >
                          <div className="newuserTooltip">
                            <a
                              onClick={() => {
                                let reRoute = window.open(
                                  sample +
                                    `/cohort-programs/all/${item.cohortApplication.id}`,
                                  "_blank"
                                );
                              }}
                              className="color-green"
                            >
                              {"C" +
                                item?.cohortApplication?.cohortId?.substring(
                                  item.cohortApplication.cohortId?.length - 6
                                )}
                            </a>
                            <span className="tooltiptext mentoricon tooltip-bottom">
                              View Cohort Details
                            </span>
                          </div>
                          <div className="mt-2">
                            {item.mentor.organization_name}
                          </div>
                          <div
                            className="mt-2 "
                            style={{ marginBottom: "40px" }}
                          >
                            {item.cohortApplication.program_name}
                          </div>
                          <div
                            className="newuserTooltip"
                            style={{
                              position: "absolute",
                              bottom: 0,
                              right: 0,
                              padding: "12px",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              let reRoute = window.open(
                                sample +
                                  `/cohort-programs/all/${item.cohortApplication.id}`,
                                "_blank"
                              );
                            }}
                          >
                            <img src={profile} height={40} width={40} />
                            <span
                              className="tooltiptext tooltip-bottom "
                              style={{
                                left: "26px",
                                top: "54px",
                                width: "150px",
                              }}
                            >
                              View Cohort Details
                            </span>
                          </div>
                        </td>

                        <td
                          style={{ verticalAlign: "middle" }}
                          className={
                            item.requestStatus !== null &&
                            item.requestStatus !== "" &&
                            item.requestStatus !== "Requested"
                              ? ""
                              : "reqStatus"
                          }
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "left",
                              alignItems: "center",
                            }}
                            className="reqstatchrtreqmenlgnmbldiv"
                          >
                            {item.requestStatus !== null &&
                            item.requestStatus !== "" &&
                            item.requestStatus !== "Requested" ? (
                              item.requestStatus
                            ) : (
                              <div className="newuserTooltip selectboxwidth">
                                <Select
                                  required={true}
                                  id="Status"
                                  variant="outlined"
                                  fullWidth
                                  margin="normal"
                                  type="State"
                                  name="Status"
                                  className="col-12 "
                                  styles={customStyles2}
                                  isSearchable={false}
                                  options={approvalOptions}
                                  value={
                                    selectedId === item.id ? approvaloption : ""
                                  }
                                  onChange={(e) => {
                                    setSelectedId(item.id);
                                    // setApprovalOption(e.value);
                                    setApprovalOption({
                                      label: e.value,
                                      value: e.value,
                                    });

                                    if (e.value === "Approve") {
                                      let params = {
                                        id: item.id,
                                        requestStatus: "Accepted",
                                        updatedBy: LoginRole.id,
                                      };

                                      updateMentorStatus(params);
                                      // postStatusMentorCohort(params);
                                      // swal({
                                      //   title: "Thank You",
                                      //   text: `Mentor's Cohort Request Accepted Successfully`,
                                      //   icon: "success",
                                      //   timer: 5000,
                                      //   // buttons: false,
                                      // }).then(function () {
                                      //   localStorage.setItem(
                                      //     "cohortMentors",
                                      //     "cohortMentors"
                                      //   );
                                      //   window.location.reload();
                                      // });
                                      // setTimeout(() => {
                                      //   localStorage.setItem(
                                      //     "cohortMentors",
                                      //     "cohortMentors"
                                      //   );
                                      //   window.location.reload();
                                      // }, 2500);
                                      setTimeout(() => {
                                        postCounterFn();
                                        if (selectedStatus === "Requested") {
                                          callTableData("Requested");
                                        } else {
                                          callTableData("");
                                        }
                                        // setSelectedStatus("Requested");
                                        setApprovalOption(null);
                                      }, 2000);
                                    } else if (e.value === "Reject") {
                                      let params = {
                                        id: item.id,
                                        requestStatus: "Declined",
                                        updatedBy: LoginRole.id,
                                      };
                                      updateMentorStatus(params);
                                      // postStatusMentorCohort(params);
                                      // swal({
                                      //   title: "Thank You",
                                      //   text: `Mentor's Cohort Request Declined Successfully`,
                                      //   icon: "success",
                                      //   timer: 5000,
                                      //   // buttons: false,
                                      // }).then(function () {
                                      //   localStorage.setItem(
                                      //     "cohortMentors",
                                      //     "cohortMentors"
                                      //   );
                                      //   window.location.reload();
                                      // });
                                      // setTimeout(() => {
                                      //   localStorage.setItem(
                                      //     "cohortMentors",
                                      //     "cohortMentors"
                                      //   );
                                      //   window.location.reload();
                                      // }, 5000);
                                      // setRejectData(params)
                                      // onclickShowSubmitAction(
                                      //   "Reject",
                                      //   item.id,
                                      //   "REJECTED"
                                      // );
                                      setTimeout(() => {
                                        postCounterFn();
                                        if (selectedStatus === "Requested") {
                                          callTableData("Requested");
                                        } else {
                                          callTableData("");
                                        }
                                        // setSelectedStatus("Requested");
                                        setApprovalOption(null);
                                      }, 2000);
                                    } else {
                                      //
                                    }
                                  }}
                                  placeholder="Select"
                                />
                                <span
                                  className="tooltiptext tooltip-bottom applustar"
                                  style={{
                                    left: "-104px",
                                    top: "-4px",
                                    width: "158px",
                                    height: "46px",
                                  }}
                                >
                                  Change Request Status
                                </span>
                              </div>
                            )}
                            <br />
                            {item.dateUpdated &&
                            item.dateUpdated !== null &&
                            item.dateUpdated !== ""
                              ? moment(item.dateUpdated).format("DD/MM/YYYY")
                              : ""}
                            <br />
                            {item.dateUpdated &&
                            item.dateUpdated !== null &&
                            item.dateUpdated !== ""
                              ? moment(item.dateUpdated).format("hh:mm A")
                              : ""}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="pagination-box">
                  {getTableDataPaginate !== undefined && (
                    <Pagination
                      activePage={activePage}
                      itemsCountPerPage={10}
                      totalItemsCount={getTableDataPaginate?.totalElements}
                      pageRangeDisplayed={5}
                      onChange={handlePageChange.bind(this)}
                    />
                  )}
                  {/* ) : (
                    ""
                    // (
                    //   <tr>
                    //     <td style={{ border: "none" }}>
                    //       {" "}
                    //       <div className="no-records">No Records Found</div>
                    //     </td>
                    //   </tr>
                    // )
                  )} */}
                </div>
              </div>
            </div>
          ) : (
            <div className="no-records">No Records Found</div>
          )}
          {/* ) : (
            <div className="no-records">No Records Found</div>
          )} */}
          <div
            className="dashboard-bottom-btn top-btn dashboardbelowBtn newuserTooltip programcohortButton"
            style={{ margin: "auto" }}
            onClick={() => {
              history.push({
                pathname: "/dashboard",
                state: {
                  fromModule: "cohortMentorRequest",
                },
              });
              props.setSelectedMenu("cohortProgram");
              // history.push("/dashboard");
              // window.location.reload();
            }}
          >
            <p style={{ cursor: "pointer" }} className="text-white3">
              VIEW COHORT PROGRAMS
            </p>
            <span
              className="tooltiptext tooltip-bottom"
              style={{ left: "410px", top: "60px", width: "220px" }}
            >
              Click to View Cohort Programs
            </span>
          </div>
        </div>
        {showSubmitAction ? (
          <SubmitAction
            isOpen={showSubmitAction}
            className={"form-submit-modal"}
            onClose={clickOnClose}
            action={action}
            submitData={submitData}
            formName={"mentorCohort"}
            rejectData={rejectData}
          />
        ) : (
          ""
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  //
  return {
    startUpApplication: state.StartUpReducer.StartUpApplications.data,
    startUpApplicationPagineate:
      state.StartUpReducer.StartUpApplications.paginate,
    getCounterStartUp: state.StartUpReducer.getCountersStartUpList.data,
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
    getNamesListData: state.AdminMentorReducer.getNamesList?.data,
    tableData: state.MentorReducer.getCohortMentorModuleList.data,
    getTableDataPaginate:
      state.MentorReducer.getCohortMentorModuleList.paginate,
    tableCounterData:
      state.MentorReducer.getStartupCohortMentorModuleCounter.data,
    updatedrequeststatus: state.MentorReducer?.setCohortMentorStatus?.status,
    getStepperData: state.AdminMentorReducer.getStepperList.list,
  };
};
export default connect(mapStateToProps, {
  //   getStartupApplication,
  //   getCountersStartUpList,
  getPredefineOptionsList,
  getNamesList,
  postStatusMentorCohort,
  postCounterStartupCohort,
  postMentorModuleCohort,
  getStepperTooltipData,
})(withRouter(CohortMentors));
